module.exports = __webpack_public_path__ + "img/homePageimg5.f651ddf4.png";